import React from 'react';
import c from 'classnames';
// import { useTranslation } from 'react-i18next';
import formElementStyles from '../../layouts/FormElement/FormElement.scss';
import s from './InputLabelText.scss';
/**
 * The text of an `<input />`'s label.
 *
 * NOTE: You still need need to wrap this in an `<InputLabel />` tag! This just provides the necessary styling to the text.
 */ const InputLabelText = ({ children, className, isRequired, onClick })=>{
    // const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], className),
        onClick: onClick
    }, children, ' ', isRequired && /*#__PURE__*/ React.createElement("span", {
        className: s['required-label']
    }, /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": "true",
        title: "Required"
    }, "*"), /*#__PURE__*/ React.createElement("span", {
        className: c(// we pull in the styles from the parent container
        // so it can use :focus-within to show 'required' when the field is focused
        formElementStyles['visually-hidden-required-text'])
    }, "Required")));
};
InputLabelText.displayName = 'InputLabelText';
export default InputLabelText;
